module.exports = __webpack_public_path__ + "img/location.85a37fe5.png";